<template>
  <div class="user-index">
    <div class="user-name">
      {{ user.name }}
    </div>
    <div class="passport-user-detail">
      <div>
        <div class="num">{{ user.studyCourseNum || 0 }}</div>
        <div>已学课程</div>
      </div>
      <div>
        <div class="num">{{ user.passportName || '-' }}</div>
        <div>护照等级</div>
      </div>
      <div>
        <div class="num">{{ user.integral.toLocaleString('en-US') || 0 }}</div>
        <div>我的学分</div>
      </div>
    </div>
    <PassportMap
      @handleMonth="handleMonth"
      :ppn="PPN"
      :showFinish="true"
      @handleShowBack="handleShowBack"
    />
    <MonthChart v-show="monthShow" :ppn="PPN" :isUser="true" />
    <div @click="$router.back()" class="back-btn" v-show="isBack">返回</div>
  </div>
</template>

<script>
import MonthChart from './monthChart.vue'
import PassportMap from './passportMap.vue'
import { getUserByPpn } from '@/api/user/index.js'
export default {
  components: { MonthChart, PassportMap },
  name: 'userIndex',
  data() {
    return {
      userName: '', //经销商名称
      monthShow: true,
      PPN: '',
      dealerId: '',
      isBack: true,
      user: { integral: 0 },
    }
  },
  methods: {
    handleMonth(e) {
      this.monthShow = e
    },
    getUser() {
      getUserByPpn({
        ppn: this.PPN,
      }).then((res) => {
        this.user = res.data
        //this.userName = res.data.name
        //this.dealerId = res.data.dealerId
      })
    },
    handleShowBack(val) {
      this.isBack = val
    },
  },
  //watch: {
  //$route() {
  // this.PPN = this.$route.query.id
  //this.getUser()
  //},
  //},
  created() {},
  mounted() {
    this.PPN = this.$route.query.id
    this.getUser()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.user-index {
  .user-name {
    font-family: 'Porsche Next';
    font-size: 15px;
    padding-left: 10px;
    font-weight: 500;
    height: 38px;
    line-height: 38px;
    color: #fff;
    background: url('../assets/img/title-red.png') center no-repeat;
    background-size: 100%;
    margin-bottom: 10px;
  }
}
.passport-user-detail {
  z-index: 9;
  position: relative;
  top: -3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 58px;
  border-radius: 0 0 6px 6px;
  background: #fff;
  margin-bottom: 5px;
  & > div {
    padding: 0 20px;
    font-size: 11px;
    text-align: center;
    color: #353535;
    font-size: 11px;
    font-weight: 400;
    .num {
      font-family: 'Porsche Next';
      font-size: 16px;

      color: #d5001c;
    }
  }
}
</style>
